import {
  Button,
  Checkbox,
  Dialog,
  FilePicker,
  Group,
  Overlay,
  Pane,
  RadioGroup,
  Spinner,
  Text,
  TextInputField,
} from "evergreen-ui";
import thaid1 from "../../assets/2026/thai/ThaID1.png";
import thaid2 from "../../assets/2026/thai/2.png";
import { IoMdHelpBuoy } from "react-icons/io";
import packkagee from "../../../package.json";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useForm } from "react-hook-form";
import axios from "axios";
import { mua } from "../MUA";
import { day, firstgen, month, objTypePre_Bak, selectorigin, selectreligion } from "./DATA/data";
import { FaFacebook } from "react-icons/fa6";
import { admission } from "../ADMISSION";
import Swal from "sweetalert2";
import Iframe from "react-iframe";
function FormProfileNewBee() {
  const {
    setValue,
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      citizent: localStorage.getItem("citizent"),
      pname: "",
      name: "",
      lname: "",
      name_eng: "",
      lname_eng: "",
      gender: "",
      bdate: "",
      ddate: "",
      mdate: "",
      ydate: "",
      telephone: "",
      line_id: "",
      email: "",
      facebookid: "",
      nation_study: localStorage.getItem("nation_name"),
      believe_study: "",
      religion_study: "",
      weight_study: "",
      height_study: "",
      waistline_study: "",
      talent_study: "",
      number_study: "",
      moo_study: "",
      soi_study: "",
      street_study: "",
      provincy_study: "",
      district_study: "",
      subdistrict_study: "",
      zipcode_study: "",
      provincework: "",
      districtwork: "",
      schoolnamework: "",
      province: "",
      province2: "",
      district: "",
      district2: "",
      schoolname: "",
      schoolname2: "",
      level: localStorage.getItem("level"),
      plan: localStorage.getItem("plan"),
      vga: localStorage.getItem("vga"),
      level2: localStorage.getItem("level2"),
      plan2: localStorage.getItem("plan2"),
      vga2: localStorage.getItem("vga2"),
      level3: localStorage.getItem("level3"),
      plan3: localStorage.getItem("plan3"),
      vga3: localStorage.getItem("vga3"),
      filelevel: null,
      fileNotTH: "",
      filelevel2: "",
      fileData_1: null,
      fileData_3: null,
      filelevel_name: "",
      fileNotTH_name: "",
      fileData_1_name: "",
      fileData_3_name: "",
      scholarship: "",
      faculty: localStorage.getItem("faculty"),
      faculty2: localStorage.getItem("faculty2"),
      faculty3: localStorage.getItem("faculty3"),
      majorid: localStorage.getItem("majorid"),
      majorid2: localStorage.getItem("majorid2"),
      majorid3: localStorage.getItem("majorid3"),
      robId: localStorage.getItem("robId"),
      typestd: localStorage.getItem("typestd"),
      typestd2: localStorage.getItem("typestd2"),
      nation: localStorage.getItem("nation"),
      typestd3: localStorage.getItem("typestd3"),
      typestudent: localStorage.getItem("typestudent"),
      news1: false,
      news2: false,
      news3: false,
      news4: false,
      news5: false,
      news6: false,
      news7: false,
      news8: false,
      news9: false,
      news10: false,
      news11: false,
      type_pre: "",
      citizent_pre: "",
      name_pre: "",
      lname_pre: "",
      number_pre: "",
      moo_pre: "",
      soi_pre: "",
      street_pre: "",
      provincy_pre: "",
      district_pre: "",
      subdistrict_pre: "",
      zipcode_pre: "",
      mobile_pre: "",
      email_pre: "",
      checkconfirm: false,
      firstgen: "",
      test: false,
      DataProvince: [],
      DataLevel: [],
      DataLevel2: [],
      DataPlan1: [],
      DataPlan2: [],
      DataPrefix: [],
      DataDistrictStudy: [],
      DataDistrictWork: [],
      DataSubDistrictStudy: [],
      DataDistrictSchool: [],
      DataDistrictSchool2: [],
      DataSchool: [],
      DataSchool2: [],
      DataSchoolWork: [],
      DataDistrictPre: [],
      DataSubDistrictPre: [],
    },
  });
  const [DataYear, setDataYear] = useState([]);
  const [isShowForm2, setisShowForm2] = useState(false);
  const [isShowForm1, setisShowForm1] = useState(false);
  const [DataRegist, setDataRegist] = useState([]);
  const FetchYear = () => {
    var newyear = new Date().getFullYear();
    var startyear = newyear - 16;
    var stopyear = newyear - 130;
    var o = 0;
    var y = [];
    while (startyear > stopyear) {
      y[o] = startyear;
      o++;
      startyear--;
    }
    const ssss = y.map((d) => ({
      value: d.toString(),
      label: (d + 543).toString(),
    }));
    setDataYear(ssss);
  };
  const FetchPrefix = async () => {
    try {
      const fetch = await axios.get(admission + "/dashboard/prefix");
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.PREFIX_NAME_ID,
          label: i.FULLNAME,
        }));
        setValue("DataPrefix", selection);
      } else {
        setValue("DataPrefix", []);
      }
    } catch (error) {}
  };

  const FetchLevel = async () => {
    try {
      const fetch = await axios.get(mua + "/admission/level");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.LEVEL_EDU_ID.toString(),
          label: i.LEVEL_EDU_NAME.toString(),
        }));
        setValue("DataLevel", selection);
      } else {
        setValue("DataLevel", []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const FetchLevel2 = async () => {
    try {
      const fetch = await axios.get(mua + "/admission/level");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.LEVEL_EDU_ID.toString(),
          label: i.LEVEL_EDU_NAME.toString(),
        }));
        setValue("DataLevel2", selection);
      } else {
        setValue("DataLevel2", []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchProvince = async () => {
    try {
      const fetch = await axios.get(mua + "/admissionnew2022/showprivenceschool");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.PROVINCE_ID,
          label: i.PROVINCE_NAME_TH,
        }));

        setValue("DataProvince", selection);
      } else {
        setValue("DataProvince", []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPlan1 = async () => {
    try {
      const fetch = await axios.post(mua + "/admission/plan", {
        level: localStorage.getItem("level"),
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.value,
          label: i.label,
        }));

        setValue("DataPlan1", selection);
      } else {
        setValue("DataPlan1", []);
      }
      //   console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPlan2 = async () => {
    try {
      const fetch = await axios.post(mua + "/admission/plan", {
        level: localStorage.getItem("level2"),
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.value,
          label: i.label,
        }));

        setValue("DataPlan2", selection);
      } else {
        setValue("DataPlan2", []);
      }
      //   console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchSchool = async (value) => {
    try {
      const fetch = await axios.get(mua + "/admissionnew2022/showlistchool/" + value);
      const data = fetch.data;
      console.log(data);
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.id_school,
          label: i.name_school,
        }));
        console.log(selection);
        return selection;
      } else {
        return [];
      }
    } catch (error) {}
  };

  const FetchProfile = async () => {
    try {
      setLoading(true);
      const fetch = await axios.post(admission + "/student/dataprofile", {
        citizen: watch("citizent"),
      });
      const data = fetch.data;

      if (data.length !== 0) {
        console.log(data);
        const profile = data[0];
        // setValue("pname", profile.PREFIX_LOGIN !== null ? profile.PREFIX_LOGIN : "");
        // setValue("name", profile.FRISTNAME_LOGIN !== null ? profile.FRISTNAME_LOGIN : "");
        // setValue("lname", profile.LASTNAME_LOGIN !== null ? profile.LASTNAME_LOGIN : "");
        // setValue("name_eng", profile.FRISTNAMEENG_LOGIN !== null ? profile.FRISTNAMEENG_LOGIN : "");
        // setValue("lname_eng", profile.LASTNAMEENG_LOGIN !== null ? profile.LASTNAMEENG_LOGIN : "");
        setValue("telephone", profile.TELMOBILE_LOGIN !== null ? profile.TELMOBILE_LOGIN : "");
        if (profile.BDATE_LOGIN !== null) {
          const bdate = profile.BDATE_LOGIN;
          const arraydate = bdate.split("-");
          setValue("ydate", arraydate[0]);
          setValue("mdate", arraydate[1]);
          setValue("ddate", arraydate[2]);
        }

        setValue(
          "email",
          profile.EMAIL_LOGIN !== null && profile.EMAIL_LOGIN !== " " ? profile.EMAIL_LOGIN : ""
        );
        setValue("facebookid", profile.FACEBOOK_LOGIN !== null ? profile.FACEBOOK_LOGIN : "");
        setValue("line_id", profile.LINE_LOGIN !== null ? profile.LINE_LOGIN : "");
        setValue("mobile_pre", profile.MOBILE_PRE !== null ? profile.MOBILE_PRE : "");
        setValue("believe_study", profile.RACE_LOGIN !== null ? profile.RACE_LOGIN : "");
        setValue("religion_study", profile.RELIGION_LOGIN !== null ? profile.RELIGION_LOGIN : "");
        setValue("number_study", profile.NUMBER_STUDY !== null ? profile.NUMBER_STUDY : "");
        setValue("moo_study", profile.MOO_STUDY !== null ? profile.MOO_STUDY : "");
        setValue("soi_study", profile.SOI_STUDY !== null ? profile.SOI_STUDY : "");
        setValue("street_study", profile.STREET_STUDY !== null ? profile.STREET_STUDY : "");
        setValue("provincy_study", profile.PROVINCY_STUDY !== null ? profile.PROVINCY_STUDY : "");
        setValue("weight_study", profile.WEIGHT_STUDY !== null ? profile.WEIGHT_STUDY : "");
        setValue("height_study", profile.HEIGHT_STUDY !== null ? profile.HEIGHT_STUDY : "");
        setValue(
          "waistline_study",
          profile.WAISTLINE_STUDY !== null ? profile.WAISTLINE_STUDY : ""
        );
        setValue("talent_study", profile.TALENT_LOGIN !== null ? profile.TALENT_LOGIN : "");
        if (profile.PROVINCY_STUDY !== "" && profile.PROVINCY_STUDY !== null) {
          const select = await FetchDistrict(profile.PROVINCY_STUDY);
          const select2 = await FetchSubDistrict(profile.DISTRICT_STUDY);
          setValue("district_study", profile.DISTRICT_STUDY);
          setValue("DataDistrictStudy", select);
          setValue("subdistrict_study", profile.SUBDISTRICT_STUDY);
          setValue("DataSubDistrictStudy", select2);
          setValue(
            "zipcode_study",
            select2?.find((option) => option.value === profile.SUBDISTRICT_STUDY).zipcode.toString()
          );
        }
        ThaiD();
        setLoading(false);
      } else {
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {}
  };
  const ThaiD = async () => {
    try {
      const fetch = await axios.post(mua + "/admissionnew2022/ProfileThaID", {
        citizen: localStorage.getItem("citizent"),
      });
      const response = await fetch.data;
      if (response.length !== 0) {
        const profile = response[0];
        console.log();
        watch("DataPrefix") &&
          setValue(
            "pname",
            profile.PNAME !== null
              ? watch("DataPrefix").filter((val) => val.label === profile.PNAME)[0].value
              : ""
          );
        setValue("name", profile.NAME !== null ? profile.NAME : "");
        setValue("lname", profile.LNAME !== null ? profile.LNAME : "");
        setValue("name_eng", profile.NAME_EN !== null ? profile.NAME_EN : "");
        setValue("lname_eng", profile.LNAME_EN !== null ? profile.LNAME_EN : "");
        // setValue("telephone", profile.TELMOBILE_LOGIN !== null ? profile.TELMOBILE_LOGIN : "");
        if (profile.BIRTHDATE !== null) {
          const bdate = profile.BIRTHDATE;
          const arraydate = bdate.split("-");
          setValue("ydate", arraydate[0]);
          setValue("mdate", arraydate[1]);
          setValue("ddate", arraydate[2]);
        }

        setValue("number_study", profile.NUMBER_HOME !== null ? profile.NUMBER_HOME : "");
        setValue("moo_study", profile.MOO_HOME !== null ? profile.MOO_HOME : "");
        setValue("soi_study", profile.SOI_HOME !== null ? profile.SOI_HOME : "");
        setValue("street_study", profile.STREET_HOME !== null ? profile.STREET_HOME : "");
        setValue("provincy_study", profile.PROVINCY_HOME !== null ? profile.PROVINCY_HOME : "");
        if (profile.PROVINCY_HOME !== "" && profile.PROVINCY_HOME !== null) {
          const select = await FetchDistrict(profile.PROVINCY_HOME);
          const select2 = await FetchSubDistrict(profile.DRICTRICT_HOME);
          setValue("district_study", profile.DRICTRICT_HOME);
          setValue("DataDistrictStudy", select);
          setValue("subdistrict_study", profile.SUBDRICTRICT_HOME);
          setValue("DataSubDistrictStudy", select2);
          setValue(
            "zipcode_study",
            select2?.find((option) => option.value === profile.SUBDRICTRICT_HOME).zipcode.toString()
          );
        }
      }
      console.log(response);

      //  setValue("religion_study", profile.RELIGION_LOGIN !== null ? profile.RELIGION_LOGIN : "");
    } catch (error) {
      console.log(error);
    }
  };

  const [Laoading, setLoading] = useState(false);
  useEffect(() => {
    ThaiD();
    FetchYear();
    FetchLevel();
    FetchPlan1();
    FetchLevel2();
    FetchPlan2();
    FetchPrefix();
    FetchProvince();
    FetchProfile();
    if (watch("typestudent") === "5") {
      setValue("faculty", "2");
      setValue("majorid", "9901");
      setValue("typestd", "6");
    }
  }, []);
  const FetchDistrict = async (value) => {
    try {
      const fetch = await axios.post(mua + "/admission/district_register", {
        provincy_study: value,
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.DISTRICT_ID,
          label: i.DISTRICT_NAME_TH,
        }));

        return selection;
      } else {
        return [];
      }
    } catch (error) {}
  };
  const FetchSubDistrict = async (value) => {
    try {
      const fetch = await axios.post(mua + "/admission/subdistrict_register", {
        district_study: value,
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.SUB_DISTRICT_ID,
          label: i.SUB_DISTRICT_NAME_TH,
          zipcode: i.ZIPCODE,
        }));

        return selection;
      } else {
        return [];
      }
    } catch (error) {}
  };
  const [LoadRegister, setLoadRegister] = useState(false);
  const onSubmit = (data) => {
    setLoadRegister(true);
    const formdata = new FormData();
    formdata.append("filelevel", data.filelevel);
    formdata.append("fileData_3", data.fileData_3);
    formdata.append("fileData_1", data.fileData_1);
    formdata.append("data", JSON.stringify(data));
    axios.post(mua + "/admissionnew2022/registers", formdata).then((res) => {
      // console.log(res.data);
      setLoadRegister(false);
      setisShowForm2(false);
      if (res.data === "success") {
        Swal.fire({
          icon: "success",
          title: "ส่งใบสมัครสำเร็จ",
          text: "กรุณารอสักครู่",
          timer: 900,
          timerProgressBar: true,
          showConfirmButton: false,
        }).then((response) => {
          window.location.href = "/" + packkagee.name + "/Dataregister";
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "ส่งใบสมัครไม่สำเร็จ",
          text: "กรุณาติดต่อ 055-706547 / 088-273-0029",
          // showConfirmButton: false,
        });
      }
    });
  };
  const CheckingForm = (data) => {
    setDataRegist(data);
    setisShowForm1(true);
  };

  return (
    <Pane className="container-sm mt-3" padding={10} elevation={0}>
      {/* <Overlay isShown={Laoading}> */}

      {Laoading && (
        <Pane display="flex" justifyContent="center" alignItems="center">
          <Spinner />
        </Pane>
      )}
      {/* </Overlay> */}

      {!Laoading && (
        <>
          <Pane>
            <h4>
              {localStorage.getItem("typestudent") === "1"
                ? "สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : localStorage.getItem("typestudent") === "2"
                ? "สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : localStorage.getItem("typestudent") === "4"
                ? "สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : localStorage.getItem("typestudent") === "7"
                ? "สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : localStorage.getItem("typestudent") === "5"
                ? " สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : ""}
            </h4>
          </Pane>
          <Pane padding={10}>
            {/* <img src={thaid1} style={{ maxWidth: 120, cursor: "pointer" }} /> */}
            <form
              className="text-center text-white"
              action="https://arit.kpru.ac.th/ap/ThaID/login.php"
              method="post"
            >
              <div className="font-smaller mt-1 ml--1 mb-1 mr--1 text-center">หรือ</div>
              <input
                type="hidden"
                name="url"
                value="https://mua.kpru.ac.th/FrontEnd_Admission/thaid/callback"
              />
              <input type="hidden" name="statusThaID" value="1" />
              <button id="btnLoginThaID" className="btn" name="button" value="thaid">
                <center>
                  <img
                    src="https://arit.kpru.ac.th/ap/ThaID/images/thaID.png"
                    class="rounded mr-1"
                    width="45"
                  />
                </center>
                <div className="d-flex flex-column">
                  <Text marginTop={10}>ใช้ข้อมูลพื้นฐานจาก ThaID</Text>
                  <Text color="red" fontSize={12}>
                    *หากไม่ใช้ สามารถกรอกข้อมูลได้ด้วยตนเอง
                  </Text>
                </div>
              </button>
            </form>
          </Pane>
          <form onSubmit={handleSubmit(CheckingForm)} className="pt-3">
            <Pane
              paddingTop={10}
              paddingX={0}
              margin={0}
              className="d-flex flex-md-row flex-column flex-wrap"
            >
              {" "}
              <Text fontSize={20} fontWeight={600} className="pt-3 col-12" fontFamily="">
                ข้อมูลพื้นฐานผู้สมัคร
              </Text>
              <Pane className="col-md-12">
                <TextInputField
                  readOnly
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  disabled
                  label="เลขบัตรประชาชน"
                  {...register("citizent", {
                    required: "กรุณากรอกชื่อ",
                  })}
                />
                {errors.citizent && (
                  <small className="text-danger">{errors.citizent.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <label
                  htmlFor="pname"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  คำนำหน้า
                </label>
                {watch("DataPrefix").length > 0 && (
                  <Select
                    options={watch("DataPrefix")}
                    {...register("pname", {
                      required: "เลือกคำนำหน้าชื่อ",
                    })}
                    placeholder="เลือก"
                    defaultValue={watch("DataPrefix")?.find(
                      (option) => option.value === watch("pname")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("pname");
                      setValue("pname", e.value);
                    }}
                  />
                )}

                {errors.pname !== undefined && (
                  <small className="text-danger">{errors.pname.message}</small>
                )}
              </Pane>
              <Pane className="col-md-5">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ชื่อภาษาไทย"
                  {...register("name", {
                    required: "กรุณากรอกชื่อภาษาไทย",
                  })}
                />
                {errors.name && <small className="text-danger">{errors.name.message}</small>}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="นามสกุลภาษาไทย"
                  {...register("lname", {
                    required: "กรุณากรอกนามสกุลภาษาไทย",
                  })}
                />
                {errors.lname && <small className="text-danger">{errors.lname.message}</small>}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ชื่อภาษาอังกฤษ"
                  {...register("name_eng", {
                    required: "กรุณากรอกชื่อภาษาอังกฤษ",
                  })}
                />
                {errors.name_eng && (
                  <small className="text-danger">{errors.name_eng.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="นามสกุลภาษาอังกฤษ"
                  {...register("lname_eng", {
                    required: "กรุณากรอกนามสกุลภาษาอังกฤษ",
                  })}
                />
                {errors.lname_eng && (
                  <small className="text-danger">{errors.lname_eng.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4 d-flex">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="เบอร์โทรศัพท์มือถือ"
                  {...register("telephone", {
                    required: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
                  })}
                />
                {errors.telephone && (
                  <small className="text-danger">{errors.telephone.message}</small>
                )}
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="เบอร์โทรศัพท์มือถือผู้ปกครอง"
                  {...register("mobile_pre", {
                    required: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
                  })}
                />
                {errors.mobile_pre && (
                  <small className="text-danger">{errors.mobile_pre.message}</small>
                )}
              </Pane>
              <Pane className="col-12 d-flex flex-md-row flex-column flex-wrap mt-2 p-0">
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="ddate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    วันเกิด
                  </label>
                  {day.length !== 0 && (
                    <Select
                      {...register("ddate", {
                        required: "เลือกคำนำหน้าชื่อ",
                      })}
                      placeholder="เลือกวันเกิด"
                      options={day}
                      defaultValue={day?.find((option) => option.value === watch("ddate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("ddate");
                        setValue("ddate", e.value);
                      }}
                    />
                  )}

                  {errors.ddate && <small className="text-danger">{errors.ddate.message}</small>}
                </Pane>
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="mdate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    เดือนเกิด
                  </label>
                  {Array.isArray(month) && (
                    <Select
                      {...register("mdate", {
                        required: "เลือกเลือกเดือนเกิด",
                      })}
                      placeholder="เลือกเดือนเกิด"
                      options={month}
                      defaultValue={month?.find((option) => option.value === watch("mdate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("mdate");
                        setValue("mdate", e.value);
                      }}
                    />
                  )}

                  {errors.mdate && <small className="text-danger">{errors.mdate.message}</small>}
                </Pane>
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="ydate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    ปีเกิด
                  </label>
                  {DataYear.length !== 0 && (
                    <Select
                      {...register("ydate", {
                        required: "กรุณาเลือกปีเกิด",
                      })}
                      placeholder="กรุณาเลือกปีเกิด"
                      options={DataYear}
                      defaultValue={DataYear?.find((option) => option.value === watch("ydate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("ydate");
                        setValue("ydate", e.value);
                      }}
                    />
                  )}

                  {errors.ydate && <small className="text-danger">{errors.ydate.message}</small>}
                </Pane>
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="อีเมล/email"
                  {...register("email", {
                    required: "กรุณากรอกอีเมล",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // regex ตรวจสอบรูปแบบอีเมล
                      message: "รูปแบบอีเมลไม่ถูกต้อง",
                    },
                  })}
                />
                {errors.email && <small className="text-danger">{errors.email.message}</small>}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ชื่อ Facebook"
                  {...register("facebookid", {
                    required: "กรุณากรอกข้อมูล",
                    minLength: {
                      // value: 4, // ต้องพิมพ์อย่างน้อย 5 ตัวอักษร
                      message: "กรุณากรอกข้อมูล Facebook",
                    },
                  })}
                />
                {errors.facebookid && (
                  <small className="text-danger">{errors.facebookid.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="Line ID"
                  {...register("line_id", {
                    required: "กรุณากรอกข้อมูล Line ID",
                    minLength: {
                      // value: 2, // ต้องพิมพ์อย่างน้อย 5 ตัวอักษร
                      message: "กรุณากรอกข้อมูล Line ID",
                    },
                  })}
                />
                {errors.line_id && <small className="text-danger">{errors.line_id.message}</small>}
              </Pane>
              <div className="col-12"></div>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  readOnly
                  disabled
                  label="สัญชาติ"
                  {...register("nation_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.nation_study && (
                  <small className="text-danger">{errors.nation_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="believe_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  เชื้อชาติ
                </label>
                {selectorigin.length !== 0 && (
                  <Select
                    {...register("believe_study", {
                      required: "กรุณาเลือกเชื้อชาติ",
                    })}
                    placeholder="กรุณาเลือกเชื้อชาติ"
                    options={selectorigin}
                    isSearchable
                    defaultValue={selectorigin?.find(
                      (option) => option.value === watch("believe_study")
                    )}
                    onChange={(e) => {
                      clearErrors("believe_study");
                      setValue("believe_study", e.value);
                    }}
                  />
                )}

                {errors.believe_study && (
                  <small className="text-danger">{errors.believe_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="religion_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  ศาสนา
                </label>
                {selectreligion.length !== 0 && (
                  <Select
                    {...register("religion_study", {
                      required: "กรุณาเลือกศาสนา",
                    })}
                    placeholder="กรุณาเลือกศาสนา"
                    options={selectreligion}
                    defaultValue={selectreligion?.find(
                      (option) => option.value === watch("religion_study")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("religion_study");
                      setValue("religion_study", e.value);
                    }}
                  />
                )}

                {errors.religion_study && (
                  <small className="text-danger">{errors.religion_study.message}</small>
                )}
              </Pane>
              {(localStorage.getItem("majorid") === "9902" ||
                localStorage.getItem("majorid") === "9903") && (
                <>
                  {/* <hr width="100%" /> */}
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="น้ำหนัก"
                      {...register("weight_study", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.weight_study && (
                      <small className="text-danger">{errors.weight_study.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="ส่วนสูง"
                      {...register("height_study", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.height_study && (
                      <small className="text-danger">{errors.height_study.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="รอบเอว"
                      {...register("waistline_study", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.waistline_study && (
                      <small className="text-danger">{errors.waistline_study.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="ความสามารถพิเศษ *ไม่มีให้ใส่ -"
                      {...register("talent_study", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.talent_study && (
                      <small className="text-danger">{errors.talent_study.message}</small>
                    )}
                  </Pane>
                </>
              )}
              <hr width="100%" />
              <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                ข้อมูลที่อยู่ตามทะเบียนบ้าน
              </Text>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="บ้านเลขที่"
                  {...register("number_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.number_study && (
                  <small className="text-danger">{errors.number_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="หมู่ที่"
                  {...register("moo_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.moo_study && (
                  <small className="text-danger">{errors.moo_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ซอย *หากไม่มี ใส่ -"
                  {...register("soi_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.soi_study && (
                  <small className="text-danger">{errors.soi_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ถนน *หากไม่มี ใส่ -"
                  {...register("street_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.street_study && (
                  <small className="text-danger">{errors.street_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="religion_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  จังหวัด
                </label>
                {watch("DataProvince").length !== 0 && (
                  <Select
                    {...register("provincy_study", {
                      required: "กรุณาเลือกจังหวัด",
                    })}
                    defaultValue={watch("DataProvince")?.find(
                      (option) => option.value === watch("provincy_study")
                    )}
                    placeholder="กรุณาเลือกจังหวัด"
                    options={watch("DataProvince")}
                    isSearchable
                    onChange={async (e) => {
                      clearErrors("provincy_study");
                      const select = await FetchDistrict(e.value);
                      setValue("DataDistrictStudy", select);
                      setValue("district_study", "");
                      setValue("subdistrict_study", "");
                      setValue("zipcode_study", "");
                      setValue("provincy_study", e.value);
                    }}
                  />
                )}

                {errors.provincy_study && (
                  <small className="text-danger">{errors.provincy_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="district_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  อำเภอ/เขต
                </label>
                {Array.isArray(watch("DataDistrictStudy")) && (
                  <Select
                    {...register("district_study", {
                      required: "กรุณาเลือกอำเภอ",
                    })}
                    placeholder="กรุณาเลือกอำเภอ"
                    options={watch("DataDistrictStudy")}
                    isSearchable
                    defaultValue={watch("DataDistrictStudy")?.find(
                      (option) => option.value === watch("district_study")
                    )}
                    onChange={async (e) => {
                      clearErrors("district_study");
                      const select = await FetchSubDistrict(e.value);
                      setValue("DataSubDistrictStudy", select);
                      setValue("subdistrict_study", "");
                      setValue("zipcode_study", "");
                      setValue("district_study", e.value);
                    }}
                  />
                )}

                {errors.district_study && (
                  <small className="text-danger">{errors.district_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="subdistrict_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  ตำบล/แขวง
                </label>
                {Array.isArray(watch("DataSubDistrictStudy")) && (
                  <Select
                    {...register("subdistrict_study", {
                      required: "กรุณาเลือกตำบล",
                    })}
                    placeholder="กรุณาเลือกตำบล"
                    options={watch("DataSubDistrictStudy")}
                    defaultValue={watch("DataSubDistrictStudy")?.find(
                      (option) => option.value === watch("subdistrict_study")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("subdistrict_study");
                      setValue(
                        "zipcode_study",
                        watch("DataSubDistrictStudy")
                          ?.find((option) => option.value === e.value)
                          .zipcode.toString()
                      );
                      setValue("subdistrict_study", e.value);
                    }}
                  />
                )}

                {errors.subdistrict_study && (
                  <small className="text-danger">{errors.subdistrict_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="รหัสไปรษณีย์"
                  {...register("zipcode_study", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.zipcode_study && (
                  <small className="text-danger">{errors.zipcode_study.message}</small>
                )}
              </Pane>
              {(localStorage.getItem("majorid") === "9902" ||
                localStorage.getItem("majorid") === "9903") && (
                <>
                  <hr width="100%" />
                  <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                    ข้อมูลผู้ปกครอง
                  </Text>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="type_pre"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      ประเภทผู้ปกครอง
                    </label>
                    <Select
                      {...register("type_pre", {
                        required: "กรุณาเลือก",
                      })}
                      placeholder="กรุณาเลือก"
                      options={objTypePre_Bak}
                      isSearchable
                      onChange={async (e) => {
                        clearErrors("type_pre");
                        setValue("type_pre", e.value);
                      }}
                    />
                    {errors.type_pre && (
                      <small className="text-danger">{errors.type_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="รหัสเลขบัตรประชาชน"
                      {...register("citizent_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.citizent_pre && (
                      <small className="text-danger">{errors.citizent_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="ชื่อภาษาไทย"
                      {...register("name_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.citizent_pre && (
                      <small className="text-danger">{errors.citizent_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="นามสกุลภาษาไทย"
                      {...register("lname_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.lname_pre && (
                      <small className="text-danger">{errors.lname_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="เบอร์โทรศัพท์"
                      {...register("mobile_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.mobile_pre && (
                      <small className="text-danger">{errors.mobile_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="E-mail *ไม่มีให้ใส่ -"
                      {...register("email_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.email_pre && (
                      <small className="text-danger">{errors.email_pre.message}</small>
                    )}
                  </Pane>

                  <Pane className="col-md-3">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="บ้านเลขที่"
                      {...register("number_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.number_pre && (
                      <small className="text-danger">{errors.number_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-3">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="หมู่ที่"
                      {...register("moo_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.moo_pre && (
                      <small className="text-danger">{errors.moo_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-3">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="ซอย *หากไม่มี ใส่ -"
                      {...register("soi_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.soi_pre && (
                      <small className="text-danger">{errors.soi_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-3">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="ถนน *หากไม่มี ใส่ -"
                      {...register("street_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.street_pre && (
                      <small className="text-danger">{errors.street_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="religion_study"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      จังหวัด
                    </label>
                    {watch("DataProvince").length !== 0 && (
                      <Select
                        {...register("provincy_pre", {
                          required: "กรุณาเลือกจังหวัด",
                        })}
                        defaultValue={watch("DataProvince")?.find(
                          (option) => option.value === watch("provincy_pre")
                        )}
                        placeholder="กรุณาเลือกจังหวัด"
                        options={watch("DataProvince")}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("provincy_pre");
                          const select = await FetchDistrict(e.value);
                          setValue("DataDistrictPre", select);
                          setValue("district_pre", "");
                          setValue("subdistrict_pre", "");
                          setValue("zipcode_pre", "");
                          setValue("provincy_pre", e.value);
                        }}
                      />
                    )}

                    {errors.provincy_pre && (
                      <small className="text-danger">{errors.provincy_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="district_pre"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      อำเภอ/เขต
                    </label>
                    {Array.isArray(watch("DataDistrictStudy")) && (
                      <Select
                        {...register("district_pre", {
                          required: "กรุณาเลือกอำเภอ",
                        })}
                        placeholder="กรุณาเลือกอำเภอ"
                        options={watch("DataDistrictPre")}
                        isSearchable
                        defaultValue={watch("DataDistrictPre")?.find(
                          (option) => option.value === watch("district_pre")
                        )}
                        onChange={async (e) => {
                          clearErrors("district_pre");
                          const select = await FetchSubDistrict(e.value);
                          setValue("DataSubDistrictPre", select);
                          setValue("subdistrict_pre", "");
                          setValue("zipcode_pre", "");
                          setValue("district_pre", e.value);
                        }}
                      />
                    )}

                    {errors.district_pre && (
                      <small className="text-danger">{errors.district_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="subdistrict_pre"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      ตำบล/แขวง
                    </label>
                    {Array.isArray(watch("DataSubDistrictPre")) && (
                      <Select
                        {...register("subdistrict_pre", {
                          required: "กรุณาเลือกตำบล",
                        })}
                        placeholder="กรุณาเลือกตำบล"
                        options={watch("DataSubDistrictPre")}
                        defaultValue={watch("DataSubDistrictPre")?.find(
                          (option) => option.value === watch("subdistrict_pre")
                        )}
                        isSearchable
                        onChange={(e) => {
                          clearErrors("subdistrict_pre");
                          setValue(
                            "zipcode_pre",
                            watch("DataSubDistrictPre")
                              ?.find((option) => option.value === e.value)
                              .zipcode.toString()
                          );
                          setValue("subdistrict_pre", e.value);
                        }}
                      />
                    )}

                    {errors.subdistrict_pre && (
                      <small className="text-danger">{errors.subdistrict_pre.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      inputHeight={38}
                      paddingTop={6}
                      marginBottom={0}
                      label="รหัสไปรษณีย์"
                      {...register("zipcode_pre", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.zipcode_pre && (
                      <small className="text-danger">{errors.zipcode_pre.message}</small>
                    )}
                  </Pane>
                </>
              )}
              <hr width="100%" />
              <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                ข้อมูลทางการศึกษา
              </Text>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#edc531"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#fdf8e1"}
                padding={15}
              >
                <Text color={"red"} fontWeight="700" fontSize="18" fontFamily="">
                  *หากไม่พบข้อมูล โทร. 055-706547 / 088-273-0029 หรือ
                </Text>
                <br />
                <Text color={"red"} fontWeight="700" fontSize={18} fontFamily="">
                  *ติดต่อที่ เพจ Facebook ={">"} :
                  <a href="https://www.facebook.com/AdmissionKPRU" target="_blank" rel="noreferrer">
                    &nbsp; &nbsp;&nbsp; <FaFacebook /> รับสมัครนักศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร
                  </a>
                </Text>
              </Pane>
              {/* ///ป ครู */}
              {localStorage.getItem("typestudent") === "5" && (
                <>
                  <Pane className="col-12 d-flex flex-md-row flex-column flex-wrap mt-2 p-0">
                    {" "}
                    <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                      ข้อมูลสถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน
                    </Text>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="provincework"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        จังหวัดที่ปฏิบัติหน้าที่/ปฏิบัติการสอน
                      </label>
                      <Select
                        {...register("provincework", {
                          required: "กรุณาเลือกจังหวัด",
                        })}
                        placeholder="กรุณาเลือกจังหวัด"
                        options={watch("DataProvince")}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("provincework");
                          const select = await FetchDistrict(e.value);
                          setValue("DataDistrictWork", select);
                          setValue("districtwork", "");
                          setValue("schoolnamework", "");
                          setValue("provincework", e.value);
                        }}
                      />
                      {errors.provincework && (
                        <small className="text-danger">{errors.provincework.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="district"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        อำเภอ/เขตที่ตั้งสถานศึกษาที่ปฏิบัติการสอน
                      </label>
                      {/* {Array.isArray("DataDistrictSchool") && ( */}
                      <Select
                        {...register("districtwork", {
                          required: "กรุณาเลือกอำเภอ/เขต",
                        })}
                        placeholder="กรุณาเลือกอำเภอ/เขต"
                        options={watch("DataDistrictWork")}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("districtwork");
                          const select = await FetchSchool(e.value);
                          setValue("DataSchoolWork", select);
                          setValue("districtwork", e.value);
                        }}
                      />
                      {/* )} */}

                      {errors.districtwork && (
                        <small className="text-danger">{errors.districtwork.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="schoolnamework"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        สถานศึกษาที่ที่ปฏิบัติการสอน
                      </label>
                      <Select
                        {...register("schoolnamework", {
                          required: "กรุณาเลือกสถานศึกษาที่ที่ปฏิบัติการสอน",
                        })}
                        placeholder="กรุณาเลือกสถานศึกษา"
                        options={watch("DataSchoolWork")}
                        isSearchable
                        onChange={(e) => {
                          clearErrors("schoolnamework");
                          setValue("schoolnamework", e.value);
                        }}
                      />
                      {errors.schoolnamework && (
                        <small className="text-danger">{errors.schoolnamework.message}</small>
                      )}
                    </Pane>{" "}
                  </Pane>
                  <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12 mt-2 mb-2">
                    ข้อมูลสถานศึกษาที่สำเร็จการศึกษา
                  </Text>
                </>
              )}
              {localStorage.getItem("typestd") === "4" ||
                (localStorage.getItem("typestd") === "7" && (
                  <Pane className="col-12 mt-2">
                    <Text fontWeight={500} fontSize={16}>
                      ระดับปริญญาตรี
                    </Text>
                  </Pane>
                ))}
              <Pane className="col-md-4">
                <label
                  htmlFor="province"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                </label>
                <Select
                  {...register("province", {
                    required: "กรุณาเลือกจังหวัด",
                  })}
                  placeholder="กรุณาเลือกจังหวัด"
                  options={watch("DataProvince")}
                  isSearchable
                  onChange={async (e) => {
                    clearErrors("province");
                    const select = await FetchDistrict(e.value);
                    setValue("DataDistrictSchool", select);
                    setValue("district", "");
                    setValue("schoolname", "");
                    setValue("province", e.value);
                  }}
                />
                {errors.province && (
                  <small className="text-danger">{errors.province.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="district"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                </label>
                {/* {Array.isArray("DataDistrictSchool") && ( */}
                <Select
                  {...register("district", {
                    required: "กรุณาเลือกอำเภอ/เขต",
                  })}
                  placeholder="กรุณาเลือกอำเภอ/เขต"
                  options={watch("DataDistrictSchool")}
                  isSearchable
                  onChange={async (e) => {
                    clearErrors("district");
                    const select = await FetchSchool(e.value);
                    setValue("DataSchool", select);
                    setValue("district", e.value);
                  }}
                />
                {/* )} */}

                {errors.district && (
                  <small className="text-danger">{errors.district.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="schoolname"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  สถานศึกษาที่สำเร็จการศึกษา
                </label>
                <Select
                  {...register("schoolname", {
                    required: "กรุณาเลือกสถานศึกษาที่สำเร็จการศึกษา",
                  })}
                  placeholder="กรุณาเลือกสถานศึกษา"
                  options={watch("DataSchool")}
                  isSearchable
                  onChange={(e) => {
                    clearErrors("schoolname");
                    setValue("schoolname", e.value);
                  }}
                />
                {errors.schoolname && (
                  <small className="text-danger">{errors.schoolname.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="level"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  วุฒิการศึกษาที่สำเร็จการศึกษา
                </label>
                {watch("DataLevel").length !== 0 && (
                  <Select
                    {...register("level", {})}
                    isDisabled
                    placeholder="กรุณาเลือกตำบล"
                    options={watch("DataLevel")}
                    defaultValue={watch("DataLevel")?.find(
                      (option) => option.value === watch("level")
                    )}
                    isSearchable
                  />
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="plan"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  แผนการเรียนที่สำเร็จการศึกษา
                </label>
                {watch("DataPlan1").length !== 0 && (
                  <Select
                    {...register("plan")}
                    isDisabled
                    options={watch("DataPlan1")}
                    defaultValue={watch("DataPlan1")?.find(
                      (option) => option.value === watch("plan")
                    )}
                    isSearchable
                  />
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  readOnly
                  inputHeight={38}
                  paddingTop={6}
                  disabled
                  marginBottom={0}
                  label="ผลการเรียนเฉลี่ย"
                  {...register("vga", {
                    required: "กรุณากรอกข้อมูล",
                  })}
                />
                {errors.vga && <small className="text-danger">{errors.vga.message}</small>}
              </Pane>
              {localStorage.getItem("typestd") === "7" && (
                <Pane className="col-12 mt-2">
                  <Text fontWeight={500} fontSize={16}>
                    ระดับปริญญาโท
                  </Text>
                </Pane>
              )}
              {localStorage.getItem("typestd") === "7" && (
                <>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="province2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    <Select
                      {...register("province2", {
                        required: "กรุณาเลือกจังหวัด",
                      })}
                      placeholder="กรุณาเลือกจังหวัด"
                      options={watch("DataProvince")}
                      isSearchable
                      onChange={async (e) => {
                        clearErrors("province2");
                        const select = await FetchDistrict(e.value);
                        setValue("DataDistrictSchool2", select);
                        setValue("district2", "");
                        setValue("schoolname2", "");
                        setValue("province2", e.value);
                      }}
                    />
                    {errors.province2 && (
                      <small className="text-danger">{errors.province2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="district2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    {/* {Array.isArray("DataDistrictSchool") && ( */}
                    <Select
                      {...register("district2", {
                        required: "กรุณาเลือกอำเภอ/เขต",
                      })}
                      placeholder="กรุณาเลือกอำเภอ/เขต"
                      options={watch("DataDistrictSchool2")}
                      isSearchable
                      onChange={async (e) => {
                        clearErrors("district2");
                        const select = await FetchSchool(e.value);
                        setValue("DataSchool2", select);
                        setValue("district2", e.value);
                      }}
                    />
                    {/* )} */}

                    {errors.district2 && (
                      <small className="text-danger">{errors.district2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="schoolname2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      สถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    <Select
                      {...register("schoolname2", {
                        required: "กรุณาเลือกสถานศึกษาที่สำเร็จการศึกษา",
                      })}
                      placeholder="กรุณาเลือกสถานศึกษา"
                      options={watch("DataSchool2")}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("schoolname2");
                        setValue("schoolname2", e.value);
                      }}
                    />
                    {errors.schoolname2 && (
                      <small className="text-danger">{errors.schoolname2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="level2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      วุฒิการศึกษาที่สำเร็จการศึกษา
                    </label>
                    {watch("DataLevel2").length !== 0 && (
                      <Select
                        {...register("level2", {})}
                        isDisabled
                        placeholder="วุฒิการศึกษาที่สำเร็จการศึกษา"
                        options={watch("DataLevel2")}
                        defaultValue={watch("DataLevel2")?.find(
                          (option) => option.value === watch("level2")
                        )}
                        isSearchable
                      />
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="plan2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      แผนการเรียนที่สำเร็จการศึกษา
                    </label>
                    {watch("DataPlan2").length !== 0 && (
                      <Select
                        {...register("plan2")}
                        isDisabled
                        options={watch("DataPlan2")}
                        defaultValue={watch("DataPlan2")?.find(
                          (option) => option.value === watch("plan2")
                        )}
                        isSearchable
                      />
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      readOnly
                      inputHeight={38}
                      paddingTop={6}
                      disabled
                      marginBottom={0}
                      label="ผลการเรียนเฉลี่ย"
                      {...register("vga2", {
                        required: "กรุณากรอกข้อมูล",
                      })}
                    />
                    {errors.vga2 && <small className="text-danger">{errors.vga2.message}</small>}
                  </Pane>
                </>
              )}
              <Text className="col-12 mt-1" fontSize={16} fontWeight={600} fontFamily="">
                ไฟล์เอกสารต่าง ๆ
              </Text>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#abc4ff"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#edf2fb"}
                padding={15}
                display={"flex"}
                gap={5}
                flexDirection={"column"}
              >
                <Text color="#274c77">
                  *หลักฐานที่อัพโหลดเข้าระบบต้องสำเนาถูกต้องและลงลายมือชื่อให้เรียบร้อย
                </Text>
                <Text color="#274c77">
                  *สำหรับผู้ที่ไม่มีสัญชาติไทยให้แนบสำเนาบัตรประจำตัวผู้ไม่มีสัญชาติไทยมากับสำเนาเอกสารใบรายงานผลการเรียนด้วย
                </Text>
                <IoMdHelpBuoy color="#ff6b35" />
                <Text color="#274c77">
                  *ลิงก์สำหรับรวมไฟล์ PDF ={">"}{" "}
                  <Button
                    type="button"
                    size="small"
                    appearance="primary"
                    intent="success"
                    onClick={() => {
                      window.open("https://www.ilovepdf.com/th/merge_pdf");
                    }}
                  >
                    คลิกที่นี่
                  </Button>
                </Text>
                <Text color="#274c77">
                  *ลิงก์สำหรับบีบอัดหรือแปลงไฟล์ ={">"}{" "}
                  <Button
                    type="button"
                    size="small"
                    appearance="primary"
                    intent="success"
                    onClick={() => {
                      window.open("https://www.ilovepdf.com/th/jpg_to_pdf");
                    }}
                  >
                    คลิกที่นี่
                  </Button>
                </Text>
              </Pane>
              {localStorage.getItem("typestudent") === "5" && (
                <Pane className="col-12 mt-2">
                  <Text
                    className="col-12 mt-1 text-danger"
                    fontSize={16}
                    fontWeight={500}
                    fontFamily=""
                  >
                    หนังสืออนุญาตให้ประกอบวิชาชีพทางการศึกษา
                  </Text>
                  <FilePicker
                    accept={".pdf"}
                    placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                    onChange={async (e) => {
                      if (e) {
                        const filee = e[0];
                        console.log(filee.size);
                        if (filee.sie > 3 * 1024 * 1024) {
                          Swal.fire({
                            icon: "warning",
                            text: "ขนาดไฟล์มากกว่า 3 MB กรุณาดำเนินการให้ถูกต้อง",
                          }).then((res) => {
                            setValue("fileData_1", null);
                          });
                        } else {
                          setValue("fileData_1", e[0]);
                        }
                      } else {
                        setValue("fileData_1", null);
                      }
                    }}
                  />
                  <input
                    {...register("fileData_1", {
                      required: "กรุณาอัพโหลดเอกสาร",
                    })}
                    className="d-none"
                  />
                  {errors.fileData_1 && (
                    <small className="text-danger">{errors.fileData_1.message}</small>
                  )}
                  <br />
                  <Text
                    className="col-12 mt-1 text-success"
                    fontSize={12}
                    fontWeight={500}
                    fontFamily=""
                  >
                    ไฟล์ตัวอย่าง
                  </Text>
                  <Button
                    onClick={() => {
                      window.open("https://mua.kpru.ac.th/imagesbg/examplefilenothai.pdf");
                    }}
                    type="button"
                    size="small"
                    appearance="primary"
                  >
                    คลิกที่นี่
                  </Button>
                </Pane>
              )}
              <Pane className="col-12 mt-2">
                <Text
                  className="col-12 mt-1 text-danger"
                  fontSize={16}
                  fontWeight={500}
                  fontFamily=""
                >
                  สำเนาเอกสารใบรายงานผลการเรียนที่สำเร็จการศึกษา
                  {localStorage.getItem("typestd") === "7" && " ระดับปริญญาโท"}
                </Text>
                <FilePicker
                  accept={".pdf"}
                  placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                  onChange={async (e) => {
                    if (e) {
                      const filee = e[0];
                      console.log(filee.size);
                      if (filee.sie > 3 * 1024 * 1024) {
                        Swal.fire({
                          icon: "warning",
                          text: "ขนาดไฟล์มากกว่า 3 MB กรุณาดำเนินการให้ถูกต้อง",
                        }).then((res) => {
                          setValue("filelevel", null);
                        });
                      } else {
                        setValue("filelevel", e[0]);
                      }
                    } else {
                      setValue("filelevel", null);
                    }
                  }}
                />
                <input
                  {...register("filelevel", {
                    required: "กรุณาอัพโหลดเอกสาร",
                  })}
                  className="d-none"
                />
                {errors.filelevel && (
                  <small className="text-danger">{errors.filelevel.message}</small>
                )}
                <br />
                <Text
                  className="col-12 mt-1 text-success"
                  fontSize={12}
                  fontWeight={500}
                  fontFamily=""
                >
                  ไฟล์ตัวอย่าง
                </Text>
                <Button
                  onClick={() => {
                    window.open("https://mua.kpru.ac.th/imagesbg/examplefilenothai.pdf");
                  }}
                  type="button"
                  size="small"
                  appearance="primary"
                >
                  คลิกที่นี่
                </Button>
              </Pane>
              <Pane className="col-12 mt-3">
                <Text
                  className="col-12 mt-1 text-danger"
                  fontSize={14}
                  fontWeight={500}
                  fontFamily=""
                >
                  สำเนาบัตรประจำตัวประชาชน / สำเนาบัตรประจำตัวบุคคลที่ไม่มีสถานะทางทะเบียน/
                  สำเนาบัตรประจำตัวคนซึ่งไม่มีสัญชาติไทย/ สำเนาหนังสือเดินทาง /
                  สำเนาเอกสารใบทะเบียนนักเรียนรายบุคคล (นักเรียนติด G)
                </Text>
                <FilePicker
                  accept={".pdf"}
                  placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                  onChange={async (e) => {
                    if (e) {
                      const filee = e[0];
                      if (filee.sie > 3 * 1024 * 1024) {
                        Swal.fire({
                          icon: "warning",
                          text: "ขนาดไฟล์มากกว่า 3 MB กรุณาดำเนินการให้ถูกต้อง",
                        }).then((res) => {
                          setValue("fileData_3", null);
                        });
                      } else {
                        setValue("fileData_3", e[0]);
                      }
                    } else {
                      setValue("fileData_3", null);
                    }
                  }}
                />
                <input
                  {...register("fileData_3", {
                    required: "กรุณาอัพโหลดเอกสาร",
                  })}
                  className="d-none"
                />
                {errors.fileData_3 && (
                  <small className="text-danger">{errors.fileData_3.message}</small>
                )}
                <br />
              </Pane>
              <hr width="100%" />
              <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                ข้อมูลทางการศึกษาบิดาหรือมารดา
              </Text>
              <Text className="col-12 mt-1">
                บิดาหรือมารดาของท่านสำเร็จการศึกษาในระดับปริญญาตรีขึ้นไป หรือไม่ ?
              </Text>
              <Pane>
                <RadioGroup
                  size={16}
                  value={watch("firstgen")}
                  defaultValue=""
                  options={firstgen}
                  onChange={(event) => setValue("firstgen", event.target.value.toString())}
                />
              </Pane>
              <hr width="100%" />
              <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                ข้อมูลช่องทางรับข่าวสาร
              </Text>
              <Text className="col-12 mt-1">
                นักศึกษาทราบช่องทางการสมัครเข้ามหาวิทยาลัยได้จากช่องทางใดบ้าง
              </Text>
              <Group flexDirection={"column"} paddingTop={10}>
                <Checkbox
                  marginBottom={5}
                  checked={watch("news1")}
                  onChange={(e) => setValue("news1", e.target.checked)}
                  label="เว็บไซต์มหาวิทยาลัยราชภัฏกำแพงเพชร"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news2")}
                  onChange={(e) => setValue("news2", e.target.checked)}
                  label="โปสเตอร์/แผ่นประกาศ/แผ่นพับ/ใบปลิว"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news3")}
                  onChange={(e) => setValue("news3", e.target.checked)}
                  label="YouTube / Tiktok"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news4")}
                  onChange={(e) => setValue("news4", e.target.checked)}
                  label="สื่อวิทยุ"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news5")}
                  onChange={(e) => setValue("news5", e.target.checked)}
                  label="ผู้ปกครอง"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news6")}
                  onChange={(e) => setValue("news6", e.target.checked)}
                  label="Facebook"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news7")}
                  onChange={(e) => setValue("news7", e.target.checked)}
                  label="ครูแนะแนว"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news8")}
                  onChange={(e) => setValue("news8", e.target.checked)}
                  label="ป้ายประชาสัมพันธ์"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news9")}
                  onChange={(e) => setValue("news9", e.target.checked)}
                  label="นิทรรศการวิชาการ"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news11")}
                  onChange={(e) => setValue("news11", e.target.checked)}
                  label="แนะแนวการศึกษาของมหาวิทยาลัย"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news10")}
                  onChange={(e) => setValue("news10", e.target.checked)}
                  label="อื่นๆ"
                />
              </Group>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#de6d17"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#fde1cb"}
                padding={15}
                display={"flex"}
                gap={5}
                flexDirection={"row"}
              >
                <Text color="#de6d17" display="flex">
                  <Checkbox
                    width={10}
                    marginRight={20}
                    checked={watch("checkconfirm")}
                    onChange={(e) => {
                      setValue("checkconfirm", e.target.checked);
                    }}
                  />
                  ข้าพเจ้าขอรับรองว่าข้อมูลในใบสมัครฉบับนี้มีความครบถ้วน
                  ถูกต้องและตรงตามความเป็นจริงทุกประการ
                  และยินยอมให้มหาวิทยาลัยราชภัฏกำแพงเพชรจัดเก็บข้อมูล เผยแพร่
                  และส่งต่อเพื่อใช้งานภายในมหาวิทยาลัยราชภัฏกำแพงเพชร
                </Text>
              </Pane>
              <Pane className="col-12 mt-3">
                <Button
                  disabled={
                    !(
                      watch("news1") ||
                      watch("news2") ||
                      watch("news3") ||
                      watch("news4") ||
                      watch("news5") ||
                      watch("news6") ||
                      watch("news7") ||
                      watch("news8") ||
                      watch("news9") ||
                      watch("news11") ||
                      watch("news10")
                    ) || !watch("checkconfirm")
                  }
                  type="submit"
                  appearance="primary"
                  intent="success"
                >
                  บันทึกการสมัครเรียน
                </Button>
              </Pane>
            </Pane>
          </form>
        </>
      )}
      <Dialog
        isShown={isShowForm1}
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={false}
        width={900}
        preventBodyScrolling={true}
        onCloseComplete={() => {
          setisShowForm1(false);
        }}
      >
        <Iframe
          url="https://docs.google.com/forms/d/1IpJ5knXxI8Mm4WnkNbDfb8EhNgWvSdUdvGDFQrAftu4/viewform?edit_requested=true"
          width="100%"
          height="500px"
          id="myIds"
          className="myClassname"
          display="initial"
          position="relative"
        />
        <Pane>
          <Button
            onClick={() => {
              setisShowForm1(false);
              onSubmit(DataRegist);
              // setisShowForm2(true);
            }}
            appearance="primary"
            intent="success"
          >
            ตอบแบบสอบถามแล้ว
          </Button>
        </Pane>
      </Dialog>
      <Dialog
        isShown={isShowForm2}
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={false}
        width={900}
        preventBodyScrolling={true}
      >
        <Iframe
          url="https://docs.google.com/forms/d/e/1FAIpQLScTL-p_m09jWYV6akyNxBoSYZTKoRDTBh7GgDeFWDqC_49GKw/viewform?edit_requested=true"
          width="100%"
          height="500px"
          id="myIds"
          className="myClassname"
          display="initial"
          position="relative"
        />
        <Pane>
          <Button
            isLoading={LoadRegister}
            onClick={() => {
              // onSubmit(DataRegist);
            }}
            appearance="primary"
            intent="success"
          >
            ตอบแบบสอบถามแล้ว
          </Button>
        </Pane>
      </Dialog>
    </Pane>
  );
}

export default FormProfileNewBee;
